export const US_STATES = [
  { ID: 1, NAME: "Alaska", CODE: "AK" },
  { ID: 2, NAME: "Alabama", CODE: "AL" },
  { ID: 3, NAME: "Arkansas", CODE: "AR" },
  { ID: 4, NAME: "Arizona", CODE: "AZ" },
  { ID: 5, NAME: "California", CODE: "CA" },
  { ID: 6, NAME: "Colorado", CODE: "CO" },
  { ID: 7, NAME: "Connecticut", CODE: "CT" },
  { ID: 8, NAME: "District", CODE: "of Columbia	DC" },
  { ID: 9, NAME: "Delaware", CODE: "DE" },
  { ID: 10, NAME: "Florida", CODE: "FL" },
  { ID: 11, NAME: "Georgia", CODE: "GA" },
  { ID: 12, NAME: "Hawaii", CODE: "HI" },
  { ID: 13, NAME: "Iowa", CODE: "IA" },
  { ID: 14, NAME: "Idaho", CODE: "ID" },
  { ID: 15, NAME: "Illinois", CODE: "IL" },
  { ID: 16, NAME: "Indiana", CODE: "IN" },
  { ID: 17, NAME: "Kansas", CODE: "KS" },
  { ID: 18, NAME: "Kentucky", CODE: "KY" },
  { ID: 19, NAME: "Louisiana", CODE: "LA" },
  { ID: 20, NAME: "Massachusetts", CODE: "MA" },
  { ID: 21, NAME: "Maryland", CODE: "MD" },
  { ID: 22, NAME: "Maine", CODE: "ME" },
  { ID: 23, NAME: "Michigan", CODE: "MI" },
  { ID: 24, NAME: "Minnesota", CODE: "MN" },
  { ID: 25, NAME: "Missouri", CODE: "MO" },
  { ID: 26, NAME: "Mississippi", CODE: "MS" },
  { ID: 27, NAME: "Montana", CODE: "MT" },
  { ID: 28, NAME: "North", CODE: "Carolina	NC" },
  { ID: 29, NAME: "North", CODE: "Dakota	ND" },
  { ID: 30, NAME: "Nebraska", CODE: "NE" },
  { ID: 31, NAME: "New", CODE: "Hampshire	NH" },
  { ID: 32, NAME: "New", CODE: "Jersey	NJ" },
  { ID: 33, NAME: "New", CODE: "Mexico	NM" },
  { ID: 34, NAME: "Nevada", CODE: "NV" },
  { ID: 35, NAME: "New", CODE: "York	NY" },
  { ID: 36, NAME: "Ohio", CODE: "OH" },
  { ID: 37, NAME: "Oklahoma", CODE: "OK" },
  { ID: 38, NAME: "Oregon", CODE: "OR" },
  { ID: 39, NAME: "Pennsylvania", CODE: "PA" },
  { ID: 40, NAME: "Rhode", CODE: "Island	RI" },
  { ID: 41, NAME: "South", CODE: "Carolina	SC" },
  { ID: 42, NAME: "South", CODE: "Dakota	SD" },
  { ID: 43, NAME: "Tennessee", CODE: "TN" },
  { ID: 44, NAME: "Texas", CODE: "TX" },
  { ID: 45, NAME: "Utah", CODE: "UT" },
  { ID: 46, NAME: "Virginia", CODE: "VA" },
  { ID: 47, NAME: "Vermont", CODE: "VT" },
  { ID: 48, NAME: "Washington", CODE: "WA" },
  { ID: 49, NAME: "Wisconsin", CODE: "WI" },
  { ID: 50, NAME: "West", CODE: "Virginia	WV" },
  { ID: 51, NAME: "Wyoming", CODE: "WY" },
] as const;

export type StateCode = (typeof US_STATES)[number]["CODE"];
